import { render } from "./PVDetailView.vue?vue&type=template&id=57c7c7ce&ts=true"
import script from "./PVDetailView.vue?vue&type=script&lang=ts"
export * from "./PVDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__